$ = require 'jquery'
Auth = require 'db/auth'
BoardSelectOrganizationView = require 'views/board-menu/board-select-organization-view'
ChangeBoardAddMemberPermsView = require 'views/board-menu/change-board-add-member-perms-view'
ChangeBoardCommentingPermsView = require 'views/board-menu/change-board-commenting-perms-view'
ChangeBoardVotingPermsView = require 'views/power-ups/voting-settings-view'
PopOver = require 'views/lib/pop-over'
SimplifiedStateManager = require 'lib/simplified-state-manager'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
l = require 'lib/localize'

module.exports = class BoardSettingsView extends View
  viewTitleKey: 'settings'

  className: 'board-menu-content-frame'

  events:
    'click .js-simple-view-opt-out': 'optOutSimplifiedView'

    'click .js-change-org:not(.disabled)': 'changeOrg'

    'click .js-toggle-covers:not(.disabled)': 'toggleCovers'

    'click .js-change-comments:not(.disabled)': 'changeCommentingPerms'
    'click .js-change-voting:not(.disabled)': 'changeVotingPerms'
    'click .js-change-add-members:not(.disabled)': 'changeAddMemberPerms'

    'click .js-toggle-org-mem-join:not(.disabled)': 'toggleSelfJoin'

    'click .js-change-cookie-settings': 'changeCookieSettings'

  initialize: ->
    @makeDebouncedMethods 'render'

    @listenTo @model, 'change', @frameDebounce @render

    @listenTo SimplifiedStateManager,
      'full-view:unlocked': @renderDebounced

    return

  render: ->
    data = @model.toJSON { prefs: true, url: true, labels: true }

    data.isLoggedIn = Auth.isLoggedIn()

    data.cardCovers = data.prefs.cardCovers
    organization = @model.getOrganization()
    data.orgDisplayName = organization?.get('displayName')
    data.hasOrg = organization?.id?

    data.votingEnabled = @model.isPowerUpEnabled('voting')
    data.commentsDisplay = l(['board pref perms', @model.getCommentPerm()])
    data.votingDisplay = l(['board pref perms', @model.getPref('voting')])
    data.invitationsDisplay = l(['board pref perms', @model.getInvitePerm()])

    # If you're the org owner, you can change the organization to nothing
    # If you're the board owner, you can change the organization to whatever
    data.canChangeOrg = organization?.owned() || @model.owned()

    if organization?.owned() && !@model.owned()
      data.setOrgNull = true

    data.hasTriggeredFullView = SimplifiedStateManager.isUnlocked('full-view')

    @$el.html(
      templates.fill(
        'board_menu_settings',
        data,
        { editable: @model.editable(), owned: @model.owned() }
      )
    )

    @

  optOutSimplifiedView: ->
    if !Auth.me().isDismissed('simplified-view-full-view')
      Auth.me().dismiss('simplified-view-full-view')
      window.location.reload()

  changeOrg: (e) ->
    Util.stop(e)

    if @model.owned()

      PopOver.toggle
        elem: $(e.target).closest('a')
        view: BoardSelectOrganizationView
        options: { @model, @modelCache }

      track("Board Menu", "Settings", "Change Org")

    else
      idOrg = @model.get('idOrganization')
      @modelCache.get('Organization', idOrg)?.boardList.remove(@model)
      @model.update 'idOrganization', ''
      PopOver.hide()
      track("Board Menu", "Settings", "Remove Org")

    return

  toggleCovers: (e, cardCovers) ->
    Util.stop(e)

    @model.setPref('cardCovers', !@model.getPref('cardCovers'))

    track("Board Menu", "Settings", "Enable/Disable Cover Images")

    return

  changeCommentingPerms: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new ChangeBoardCommentingPermsView({ @model, @modelCache })

    track("Board Menu", "Settings", "Open Change Commenting Permissions")

    return

  changeVotingPerms: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new ChangeBoardVotingPermsView({ @model, @modelCache })

    track("Board Menu", "Settings", "Open Change Voting Permissions")

    return

  changeAddMemberPerms: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new ChangeBoardAddMemberPermsView({ @model, @modelCache })

    track("Board Menu", "Settings", "Open Change Add Member Permissions")

    return

  toggleSelfJoin: (e) ->
    Util.stop(e)

    @model.setPref('selfJoin', !@model.getPref('selfJoin'))
    @model.save()

    track("Board Menu", "Settings", "Toggle Allow Org Join")

    return

  changeCookieSettings: ->
    trackUe('boards sidebar', 'opens', 'cookie settings')
    window.trelloCookieConsentDialog()



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-settings-view.coffee